"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledQuestionStatusBadge = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.StyledQuestionStatusBadge = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  background-color: ", ";\n  border: ", ";\n  border-radius: ", ";\n  color: ", ";\n  height: 24px;\n  width: 80px;\n\n  > i {\n    font-size: ", ";\n  }\n"], ["\n  ", ";\n  background-color: ", ";\n  border: ", ";\n  border-radius: ", ";\n  color: ", ";\n  height: 24px;\n  width: 80px;\n\n  > i {\n    font-size: ", ";\n  }\n"])), function (_a) {
    var Utilities = _a.theme.Utilities;
    return Utilities.Flex.center('both');
}, function (_a) {
    var status = _a.status, Colors = _a.theme.Colors;
    return "".concat(status === 'correct'
        ? Colors.success
        : status === 'incorrect'
            ? Colors.Typography.hint
            : Colors.white);
}, function (_a) {
    var status = _a.status, Colors = _a.theme.Colors;
    return "".concat(status === 'partially_correct' ? "1px solid ".concat(Colors.success) : null);
}, function (_a) {
    var Dimensions = _a.theme.Dimensions;
    return Dimensions.Borders.Radiuses.medium;
}, function (_a) {
    var status = _a.status, Colors = _a.theme.Colors;
    return "".concat(status === 'correct' ? Colors.white : status === 'incorrect' ? Colors.dark : Colors.success);
}, function (_a) {
    var Iconology = _a.theme.Iconology;
    return Iconology.Sizes.sm;
});
var templateObject_1;
